<template>
  <Head>
    <title>Избранное {{ $titleEnd }}</title>
    <meta property="og:title" :content="'Избранное ' + $titleEnd" />
  </Head>
  <main class="main">
    <div class="container">
      <Breadcrumbs
        :links="[{ name: 'Home', text: 'Главная' }, { text: 'Избранное' }]"
      />
      <div class="plan-favourites">
        <h1 class="h2">Избранное</h1>
        <div v-if="favouritesLength > 0" class="count">
          Всего: {{ favouritesLength }}
          {{
            $filters.declOfNum(favouritesLength, [
              "квартира",
              "квартиры",
              "квартир",
            ])
          }}
        </div>
        <Flats
          v-if="mq.mdMinus && filteredFlats.length > 0 && flats.length > 0"
          :flats="filteredFlats"
        />
        <FlatsTable
          v-if="mq.lgPlus && filteredFlats.length > 0 && flats.length > 0"
          :flats="filteredFlats"
        />
        <div v-if="favouritesLength == 0" class="not-found text-center">
          <p>В избранном ничего нет.</p>
          <p>
            <router-link class="btn btn-default" :to="{ name: 'PlanSearch' }">
              Подобрать квартиру
            </router-link>
          </p>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import axios from "axios";
import Breadcrumbs from "@/components/UI/Breadcrumbs.vue";
import Flats from "@/components/FlatsList.vue";
import FlatsTable from "@/components/FlatsTable.vue";
// import commerceFlats from "@/content/commerce.js";
// import unicLots from "@/content/unicLots.js";
import { Head } from "@vueuse/head";
export default {
  name: "Favorites",
  components: {
    Head,
    Breadcrumbs,
    Flats,
    FlatsTable,
  },
  inject: ["favouritesStore", "mq"],
  data() {
    return {
      flats: [],
    };
  },
  computed: {
    favouritesLength() {
      return this.favouritesStore.state.favourites.length;
    },
    filteredFlats() {
      let filtered = this.flats.filter((flat) =>
        this.favouritesStore.state.favourites.includes(flat.id)
      );
      const priorityLots = filtered.filter(
        (flat) => flat?.properties?.priority_lot
      );
      const regularLots = filtered.filter(
        (flat) => !flat?.properties?.priority_lot
      );

      return [...priorityLots, ...regularLots];
    },
  },
  async mounted() {
    try {
      const response = await axios.get(
        this.$endpoint + "building-objects/" + this.$project + "/properties"
      );
      const data = response.data.data;
      this.flats = data;
    } catch (err) {
      // this.$Progress.fail();
    } finally {
      // this.$Progress.finish();
    }
  },
};
</script>

<style scoped>
.h2 {
  font-size: 80px;
}
@media (max-width: 767px) {
  .h2 {
    font-size: 36px;
  }
}

.plan-favourites {
  position: relative;
}

.breadcrumbs {
  margin-bottom: 50px;
}
@media (max-width: 767px) {
  .breadcrumbs {
    margin-bottom: 40px;
  }
}

.count {
  position: absolute;
  font-weight: 500;
  top: 0;
  right: 0;
  font-weight: normal;
}

.not-found {
  font-size: 20px;
}
/* @media (max-width: 1279px) {
  .count {
    top: 39px;
  }
} */
/* @media (max-width: 991px) {
  .count {
    top: 36px;
  }
} */
/* @media (max-width: 767px) {
  .count {
    top: 33px;
  }
} */
@media (max-width: 575px) {
  .count {
    position: relative;
    top: auto;
    right: auto;
    margin: -5px 0 13px;
  }
}
</style>
